import { ModuleStatus } from './inverter-status.constants';

export interface DeviceActionContext {
  isOnline: boolean | null;
  loggerStatus: ModuleStatus;
  isUpgrading: boolean;
  ahOperational?: string;
  isCertified?: boolean;
}

export interface DeviceActionStrategy {
  canUpgrade(ctx: DeviceActionContext): boolean;
  canConfigure(ctx: DeviceActionContext): boolean;
}

/**
 * AzzurroHub: upgrades go over MQTT/Ethernet — the device MUST be connected.
 * Also respects gateway operational state and device certification.
 */
export const azzurroHubStrategy: DeviceActionStrategy = {
  canUpgrade({ isOnline, ahOperational, isCertified }: DeviceActionContext): boolean {
    if (ahOperational === 'busy' || isCertified === false) {
      return false;
    }
    return isOnline === true;
  },

  canConfigure({ isOnline, loggerStatus, isUpgrading, ahOperational, isCertified }: DeviceActionContext): boolean {
    if (ahOperational === 'busy' || isCertified === false) {
      return false;
    }
    if (isOnline !== true) {
      return false;
    }
    if (loggerStatus === 'needs_update') {
      return false;
    }
    return !isUpgrading;
  },
};

/**
 * Solarman: logger upgrades go through the Solarman API, inverter upgrades
 * through getCommunicationChannelForStick (GraphQL). Neither depends on the
 * AWS DynamoDB connection status, so we only block when the device is
 * **explicitly** disconnected — unknown (null) is allowed.
 * The upgrade-inverter component performs its own online check at runtime.
 */
export const solarmanStrategy: DeviceActionStrategy = {
  canUpgrade({ isOnline }: DeviceActionContext): boolean {
    return isOnline !== false;
  },

  canConfigure({ isOnline, loggerStatus, isUpgrading }: DeviceActionContext): boolean {
    if (isOnline !== true) {
      return false;
    }
    if (loggerStatus === 'needs_update') {
      return false;
    }
    return !isUpgrading;
  },
};

export function getDeviceActionStrategy(isAzzurroHub: boolean): DeviceActionStrategy {
  return isAzzurroHub ? azzurroHubStrategy : solarmanStrategy;
}
